import { ContactFormState } from '../../slices/contactForm';

export type LegacyTerrainContactFormFetcherArgs = {
  code?: null | string;
  name: string;
  email: string;
  terrainUri: string;
  phone: string;
  message: string;
  terrainTitle: string;
  terrainId: number;
  recaptchaToken: string;
  recaptchaAction: string;
  source: ContactFormState['source'];
};

export default async function legacyTerrainContactFormFetcher({
  code,
  name,
  email,
  terrainUri,
  phone,
  message,
  terrainTitle,
  terrainId,
  recaptchaToken,
  recaptchaAction,
  source
}: LegacyTerrainContactFormFetcherArgs) {
  let legacySource = '';

  if (source === 'whatsapp') {
    legacySource = 'WhatsApp';
  }

  const query = new URLSearchParams({
    'nombre': name,
    email,
    'op': terrainUri,
    'pais': process.env.NEXT_PUBLIC_COUNTRY,
    'telefono': phone.replace(/\s/g, ''),
    'mensaje': message,
    'pub': terrainTitle,
    'type': 'ficha',
    'acepta': '1',
    'id': terrainId.toString(),
    'g-recaptcha-response': recaptchaToken,
    'url': '',
    'enviar': legacySource,
    source,
    recaptchaAction,
    ...(code && {
      codigo: code
    })
  }).toString();

  return fetch(`${process.env.NEXT_PUBLIC_LEGACY_HOST}/sender.php?${query}`, {
    method: 'GET',
    redirect: 'manual'
  });
}
